<template>
    <div class="wrapper">
        <MaltIllustration name="folder-empty--high" alt="" width="243" />
        <h2>{{ t('projectclient.projectlist.noprojects.header') }}</h2>
        <VJoyButton href="/s/advanced?brief_origin=mission_empty_state" variant="main">
            {{ t('projectclient.projectlist.noprojects.button.postproject') }}
        </VJoyButton>
    </div>
</template>

<script setup lang="ts">
    import {MaltIllustration} from '#components';
    import {useTranslation} from '#imports';

    import {VJoyButton, VJoyIcon, VJoyWrapper} from '@maltjoy/core-vue';

    const {t} = useTranslation();
</script>

<style lang="scss" scoped>
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/text';

    .wrapper {
        text-align: center;
        position: relative;
        top: 30%;

        & > h2 {
            color: var(--joy-color-neutral-60);

            @include text.getFontBySize(primary-650);

            margin: 32px 0;
        }
    }
</style>
